import React from 'react'
import Typewriter from 'typewriter-effect';


function typewriter() {
    return (
        <div>
            <Typewriter
                options={{
                    strings: ['Whimsical Soul ✨', 'Full Stack Dev 🚀', 'Problem Solver 🛠', 'Techie 💻', 'Audiophile 🎧', 'Wanderlust ✈️', 'Gaming Enthusiast 👾'],
                    autoStart: true,
                    loop: true,
                    changeDelay: 'natural',
                    cursor: '|',
                    changeDeleteSpeed: 1000,
                }}
            />
        </div>
    )
}

export default typewriter
